export default "__VITE_ASSET__f86767e2__"